import { ESessionActionTypes } from '../../actions/usersSession';
import { EWsSessionActionTypes } from '../../actions/wsSession';
import { ERequestApiStatus, TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';
import { ISessionInitialState, ISessionSucceedState } from '../../types/session';

export function sessionReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case ESessionActionTypes.SetSucceed:
      return {
        ...state,
        session: {
          ...state.session,
          status: ERequestApiStatus.Succeed,
          startSessionDate: new Date(),
          token: action.payload,
        },
        user: {
          ...state.user,
          userId: action.payload.userId,
        },
      };
    case ESessionActionTypes.SetFailed:
      return {
        ...state,
        session: {
          ...state.session,
          status: ERequestApiStatus.Failed,
          startSessionDate: null,
          token: null,
        } as ISessionInitialState,
      };
    case ESessionActionTypes.SetPending:
      return {
        ...state,
        session: {
          ...state.session,
          status: ERequestApiStatus.Pending,
        },
      };
    case EWsSessionActionTypes.SetWsRegistration:
      return {
        ...state,
        session: {
          ...state.session,
          uid: action.payload,
        } as ISessionSucceedState,
      };
    default:
      return state;
  }
}
